import React, { useMemo } from 'react';
import Authenticated from '@/Layouts/Authenticated';
import { Head, Link } from '@inertiajs/inertia-react';
import _date from '@/helpers/date';
import { SuccessIcon, WarningIcon } from '@/Components/SweetAlertIcons';
import { removeDuplicatesById } from '@/helpers/array';
import numberFormat from '@/helpers/numberFormat';
import OrderCard from '@/Components/SalesDaily/OrderCard';
const { DateTime } = require("luxon");

export default function ShowOrders({ auth, errors, date, office, store, orders, products, ...props}) {
    // const ordersWithoutValidations = useMemo(() => orders.filter(order => order.validations.every(validation => !validation.consumed)), [orders]);
    // const ordersWithValidations = useMemo(() => orders.filter(order => order.validations.some(validation => validation.consumed)), [orders]);

    const dateObj = DateTime.fromISO(date);
    const title = `Resumen validaciones: ${dateObj.toLocaleString(DateTime.DATE_FULL) }`

    const Header = () =>
        <div className='flex justify-between gap-2'>
            <h2 className="font-semibold text-lg sm:text-xl text-gray-800 leading-tight">
                {title}
            </h2>
            <Link href={route('schedule.index', office)}>
                ← Volver
            </Link>
        </div>


    const [totalTickets, totalPrice] = orders.reduce((acc, order) => {
        const tickets_number = order.parsed.tickets_number;
        return [
            acc[0] + tickets_number,
            acc[1] + order.parsed.totals.total,
        ];
    }, [0, 0]);
    // const notValidated = orders.filter(order => order.schedules.some(schedule => !schedule.pivot.verified_by));


    // .schedules.some().filter(r => r.verified_by === null);

    // console.log({notValidated});

    return (
        <Authenticated
            branchOffice={office}
            store={store}
            auth={auth}
            errors={errors}
            header={<Header/>}
        >
            <Head title={title} />

            <div className="py-12 max-w-7xl px-4 sm:px-6 lg:px-8 mx-auto flex flex-col gap-10">
                {/* {validators.map(validator => {
                    return (
                        <Validator key={validator.id} office={office} {...validator} />
                    )
                })} */}
                {/* <OrderCard title="Tickets validados" office={office} orders={ordersWithValidations} />
                <OrderCard title="Tickets no validados" office={office} orders={ordersWithoutValidations} /> */}
                <OrderCard title="Ventas por Mercado Pago" office={office} orders={orders.filter(order => Boolean(order.mercadopago_order))} products={products} />
                <OrderCard title="Ventas manuales" office={office} orders={orders.filter(order => !Boolean(order.mercadopago_order))} products={products} />
                <div className='px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg'>
                    <div className="flex items-center justify-between gap-4 mb-2">
                        <h2 className='text-gray-900 text-lg font-bold'>Total del día</h2>
                        <h2 className='text-gray-900 text-lg font-bold'>${numberFormat(totalPrice, 0, '', '.')}</h2>
                    </div>
                </div>
                {/* <OrderCard title="Totales" office={office} orders={orders} products={products} /> */}
            </div>

            <div className='pb-12 max-w-7xl mx-auto sm:px-6 lg:px-8 flex justify-between px-4'>
                <Link
                    className='px-4 py-2 bg-gray-900 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest active:bg-gray-900 transition ease-in-out duration-150'
                    href={route('validations.index', {office:office.slug, 'date': dateObj.plus({days: -1}).toISODate() })}
                >
                    Anterior
                </Link>
                <Link
                    className='px-4 py-2 bg-gray-900 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest active:bg-gray-900 transition ease-in-out duration-150'
                    href={route('validations.index', {office:office.slug, 'date': dateObj.plus({days: 1}).toISODate() })}
                >
                    Siguiente
                </Link>
            </div>
        </Authenticated>
    );
}
